import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userisloggued: false,
    bearer: '',
    username: 'mon nom',
    isadmin: '',
    mustcompleteprofile: false,
    showExam: false,
    exampassed: false,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
